import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { Typography } from '@mui/material';
import styled from 'styled-components';
import { capitalizeWords } from '../../../utils/common';

export const CollapseArrowIcon = styled(KeyboardArrowDownRoundedIcon)<{
  $expanded: boolean;
  $dimWhenCollapsed?: boolean;
}>`
  transition: transform 0.2s ease, opacity 0.2s ease;
  transform: rotate(${({ $expanded }) => ($expanded ? '0deg' : '-90deg')});
  font-size: 18px;
  color: ${({ theme }) => theme.palette.common.gray4};
  opacity: ${({ $expanded, $dimWhenCollapsed = true }) =>
    $expanded || !$dimWhenCollapsed ? 1 : 0};
`;

export const formatToolName = (name: string = '') =>
  name.includes('graphql')
    ? 'Search Elementary Data'
    : capitalizeWords(name.replaceAll('_', ' '));

export const ToolText = styled(Typography)<{ $running?: boolean }>`
  color: ${({ theme }) => theme.palette.common.magenta};
  font-size: 14px;
  margin: 4px 0;
  position: relative;

  ${({ $running }) =>
    $running &&
    `
    animation: shimmer 1.5s ease-in-out infinite;
    
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, 
        transparent 0%, 
        rgba(255, 255, 255, 0.6) 50%, 
        transparent 100%);
      animation: shimmerSlide 1.5s ease-in-out infinite;
    }
    
    @keyframes shimmer {
      0%, 100% {
        opacity: 0.7;
      }
      50% {
        opacity: 1;
      }
    }
    
    @keyframes shimmerSlide {
      0% {
        left: -100%;
      }
      100% {
        left: 100%;
      }
    }
  `}
`;
